import "core-js/modules/es.array.join";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
export function formatDate(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "yyyy-MM-dd";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  var o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      // let str = o[k] < 10 ? "0" + o[k] : o[k] + "";
      var str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }

  return fmt;
}
export function hasClass(el, className) {
  var reg = new RegExp("(^|\\s)" + className + "(\\s|$)");
  return el ? reg.test(el.className) : null;
}
export function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  var newClass = el.className.split(" ");
  newClass.push(className);
  el.className = newClass.join(" ");
}
export function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return;
  }

  var reg = new RegExp("(^|\\s)" + className + "(\\s|$)", "g");
  el.className = el.className.replace(reg, " ");
}